import useModal from 'hooks/useModal'
import { useCallback, useMemo } from 'react'
import MobileBalanceActionModal from '../components/MobileBalanceActionModal'

export const useMobileBalanceAction = () => {
  const [onPresent, onDismiss] = useModal(MobileBalanceActionModal)

  const handlePresentMobileBalanceAction = useCallback(() => {
    onPresent()
  }, [onPresent])

  return useMemo(() => ({ handlePresentMobileBalanceAction, onDismiss }), [handlePresentMobileBalanceAction, onDismiss])
}
